// @eslint-disable jquery,$

function productTitleHeight(checkHeight) {
	var _y = false
	$(".h4.grid-view-item__title.product-card__title").each(function (i, e) {
		const _o = $(e).height()
		let _p = "lol"
		if (_o > checkHeight) {
			_y = true
			_p = _p == "lol" ? $(e).parents(".swiper") : _p
			$(e).parent().css("margin", 0)
		}

		//     if (_y) {
		//       if (_p == 'lol') {
		//         $(e).parent().css('margin', 0)
		//       } else {
		//       _p.find('.product-meta-wrapper > div:not(.jdgm-widget)').css('margin', 0)
		//     }
		//     }
	})
}

function klaut(ww) {
	if (ww > 1280) {
		productTitleHeight(29)
		//        console.log('w here 3 3')
	} else if (ww > 1024) {
		//        console.log('w here 2')
		productTitleHeight(22)
	} else if (ww > 767) {
		//       console.log('w here')
		productTitleHeight(22)
	} else if (ww > 400) {
		//       console.log('w here')
		productTitleHeight(17)
	} else {
		productTitleHeight(22)
	}
}

// Swiper slide for homepage.
jQuery(function ($) {
	$(".product-form__input-wrap button").on("click", function () {
		var $button = $(this)
		var oldValue = $button.parent().find("input").val()
		const minBtn = $(".product-form__input-wrap button").first()
		const qtyType = $button.data("qty")

		if (qtyType == "add") {
			var newVal = parseFloat(oldValue) + 1

			minBtn.removeAttr("disabled")
		} else {
			if (oldValue > 1) {
				var newVal = parseFloat(oldValue) - 1
			} else {
				newVal = 1
			}

			if (newVal <= 1) {
				minBtn.attr("disabled", "disabled")
			}
		}

		$button.parent().find("input").val(newVal)
	})

	const ww = $(window).width()
	klaut(ww)

	$(window).resize(function () {
		const ww = $(window).width()

		klaut(ww)
	})

	// Product page info - tabbed.
	$(".product-info-tabs span").on("click", function () {
		if ($(this).hasClass("active")) return

		const idx = $(this).data("info")
		$(this).siblings().removeClass("active")
		$(this).addClass("active")

		$("div[data-info-cont]").removeClass("active")
		$("div[data-info-cont]").hide()

		$('div[data-info-cont="' + idx + '"').fadeIn("fast", function () {
			$(this).addClass("active")
		})
	})
})
